import _ from 'underscore';
import * as auctionlook from '../transforms/auctionlook_api';

export const SOURCE_AUCTIONLOOK = 'auctionlook';

export const OBJECT_PHOTO = 'photo';
export const OBJECT_AUCTION = 'auction';
export const OBJECT_AUCTIONEER = 'auctioneer';
export const OBJECT_CATEGORY = 'category';
export const OBJECT_EXPERTISE = 'expertise';
export const OBJECT_PAGINATED_LIST = 'paginatedList';
const OBJECTS = [
    OBJECT_PHOTO,
    OBJECT_AUCTION,
    OBJECT_AUCTIONEER,
    OBJECT_CATEGORY,
    OBJECT_EXPERTISE,
    OBJECT_PAGINATED_LIST
];

let _currentSource = SOURCE_AUCTIONLOOK;
export const setSource = (source) => _currentSource = source;

const API_MAP = {
    [SOURCE_AUCTIONLOOK]: auctionlook
};

const _verifySourceAndObjectType = (objectType) => {
    if (!API_MAP.hasOwnProperty(_currentSource)) {
        throw new Error(`Unable to find API source: ${_currentSource}`);
    }
    if (!_(OBJECTS).contains(objectType)) {
        throw new Error(`Invalid objectType: ${objectType}`);
    }
    if (!API_MAP[_currentSource][objectType]) {
        throw new Error(`Provided source ${_currentSource} doesn't contain transform for type ${objectType}`);
    }
};

export const getTransform = (objectType) => {
    _verifySourceAndObjectType(objectType);
    
    return API_MAP[_currentSource][objectType];
};
